import { gql } from '@apollo/client';

export const UNSUBSCRIBE_CONSUMER = gql`
  mutation UnsubscribeConsumerByTicket($unsubscriptionInfo: UnsubscriptionInfoDtoInput) {
    unsubscribeConsumerByTicket(unsubscriptionInfo: $unsubscriptionInfo)
  }
`;